import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { belowBreakpoint, breakpoints } from '../../sessions-timetable/utils';
import CurrencyHelper from '../helpers/CurrencyHelper';

const Container =
  /** @type {import('styled-components').ThemedStyledFunction<'div', {horizontal:boolean}>} */
  (styled.div)`
    padding: 1rem 1rem 2rem;
    display: flex;
    flex-direction: row;

    ${(props) =>
      props.horizontal &&
      css`
        flex-direction: column;
        margin-left: auto;
        width: max-content;
      `}

    ${belowBreakpoint(breakpoints.md)} {
      padding: 0.5rem 0.5rem 0.5rem 0;
    }
  `;

const Price = ({ horizontal = false, priceText }) => {
  return (
    <div
      style={{ marginLeft: horizontal ? 0 : 5, marginRight: horizontal ? 0 : 5 }}
      className="Price"
    >
      {priceText}
    </div>
  );
};

const PricingBox = ({ price, horizontal = false }) => {
  return (
    <Container horizontal={horizontal}>
      {price.offers && <b>Pay & Play:</b>}
      {price.offers &&
        price.offers
          .filter((offer) => offer.price && offer.price > 0)
          .map((offer) => (
            <Price
              key={offer.name}
              horizontal={horizontal}
              priceText={`${offer.name.replace('Public', '')}: ${CurrencyHelper.format(
                'en-GB',
                offer.priceCurrency,
                offer.price
              )}`}
            />
          ))}
    </Container>
  );
};

Price.propTypes = {
  horizontal: PropTypes.bool,
  priceText: PropTypes.string,
};

PricingBox.propTypes = {
  price: PropTypes.shape({
    opportunityPrice: PropTypes.string,
    offers: PropTypes.arrayOf(PropTypes.object),
  }),
  horizontal: PropTypes.bool,
};

/**
 * @param {Object} price
 * @param {boolean} showPrices
 * @param {boolean} horizontal
 * @returns {React.ReactNode}
 */
function renderPricingBox(price, showPrices, horizontal = false) {
  if (!showPrices) {
    return null;
  }
  return <PricingBox price={price} horizontal={horizontal} />;
}

export { renderPricingBox };
